/* src/app/components/general/side-bar/side-bar.component.scss */
:host {
  display: flex;
}
.container {
  background-color: #45518a;
  min-width: 53px;
  box-shadow: -4px 0 8px 2px rgba(69, 81, 138, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-top: 11px;
}
.container__top-part {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
}
.container__icons-container {
  margin-top: 67px;
  width: 100%;
}
.container__help-icon {
  color: #e0e6fe;
  height: 30px;
  width: 30px;
  margin-bottom: 30px;
  cursor: pointer;
  transition: opacity 0.12s linear;
}
.container__help-icon:hover {
  opacity: 0.7;
}
.container__icon-wrapper {
  height: 50px;
  -webkit-user-select: none;
  user-select: none;
  color: #e0e6fe;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-start-start-radius: 5px;
  border-end-start-radius: 5px;
  cursor: pointer;
  transition: opacity 0.12s linear, background-color 0.12s linear;
  margin-inline-start: 5px;
}
.container__icon-wrapper--disabled {
  pointer-events: none;
}
.container__icon-wrapper:hover mat-icon {
  opacity: 0.7;
}
.container__icon-wrapper--selected {
  width: calc(100% - 5px);
  background-color: #ffffff;
  color: #45518a;
}
.container__icon-wrapper mat-icon {
  height: 20px;
  width: 20px;
  margin-inline-end: 5px;
  transition: opacity 0.12s linear;
}
.container__icon-wrapper mat-icon:hover,
.container__icon-wrapper mat-icon.menu-open {
  opacity: 0.7;
}
.container__logo {
  color: #fff;
}
.container__logo mat-icon {
  height: 33px;
}
/*# sourceMappingURL=side-bar.component.css.map */
